import type { BusinessSection } from "./BusinessSidebar";
import { businessProfile } from "../../../mocks/businessData";

const SECTION_META: Record<BusinessSection, { title: string; subtitle: string; icon: string }> = {
  profile:   { title: "İşletme Profilim",   subtitle: "Bilgilerinizi düzenleyin",               icon: "ri-building-line" },
  gallery:   { title: "Görseller & Galeri", subtitle: "Fotoğraf yönetimi",                      icon: "ri-image-line" },
  campaigns: { title: "Kampanyalar",         subtitle: "Kampanya ve kupon yönetimi",             icon: "ri-coupon-line" },
  support:   { title: "Destek Al",           subtitle: "Destek taleplerinizi yönetin",           icon: "ri-customer-service-2-line" },
  brochure:  { title: "Broşür Talep Et",    subtitle: "Dijital ve basılı broşür isteyin",       icon: "ri-file-text-line" },
  advertise: { title: "Reklam Ver",          subtitle: "Sponsorlu içerik ve reklam paketleri",   icon: "ri-megaphone-line" },
  contact:   { title: "Yönetici ile İletişim", subtitle: "Site yönetimiyle doğrudan iletişim", icon: "ri-mail-send-line" },
};

interface BusinessTopBarProps {
  section: BusinessSection;
}

export default function BusinessTopBar({ section }: BusinessTopBarProps) {
  const meta = SECTION_META[section];

  return (
    <header className="h-16 bg-white border-b border-stone-100 flex items-center justify-between px-6 flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-50">
          <i className={`${meta.icon} text-emerald-700 text-base`} />
        </div>
        <div>
          <h1 className="font-semibold text-stone-800 text-sm leading-tight">{meta.title}</h1>
          <p className="text-xs text-stone-400">{meta.subtitle}</p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span className="hidden md:flex items-center gap-2 text-xs text-stone-400">
          <i className="ri-map-pin-line text-stone-300" />
          {businessProfile.address}
        </span>

        {businessProfile.isPublished && (
          <a
            href={`/venue/${businessProfile.id}`}
            target="_blank"
            rel="noreferrer"
            className="hidden md:flex items-center gap-1.5 px-3 py-1.5 border border-stone-200 rounded-xl text-xs text-stone-600 hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-external-link-line" />
            Sayfama Git
          </a>
        )}

        <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl border border-stone-200 cursor-pointer hover:bg-stone-50 transition-colors">
          <div className="w-6 h-6 rounded-full bg-emerald-700 flex items-center justify-center text-white text-xs font-bold">
            {businessProfile.ownerAvatar}
          </div>
          <span className="text-sm text-stone-700 font-medium hidden md:block">{businessProfile.ownerName}</span>
          <i className="ri-arrow-down-s-line text-stone-400 text-sm" />
        </div>
      </div>
    </header>
  );
}
